export const DELIVERY_CHANNEL = [
  'Selecciona una opción',
  'Delivery',
  'Take away',
];
